module.exports = __webpack_public_path__ + "81857622.png";